<script setup>
import { navigateTo, navigationItemsPersonal } from '../../../../utilities/account/useAccountNavigationPersonal'
import { formatCountry, formatDate, formatGender } from '../../../../utilities/helpers'
import AccountPanelIcon from '../../AccountPanelIcon.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import {
    isNaturalProfileAttributeHidden,
    isRequiredNaturalProfileAttributesForInvestment,
    isRequiredRequiredNaturalProfileAttributes,
} from '../../../../validation'

const { naturalProfile: account } = usePersonalAccountDataState()

const emit = defineEmits(['edit'])

function edit() {
    emit('edit')
    navigateTo('Personal Data')
}
</script>

<template>
    <div class="flex flex-wrap pb-6">
        <div class="flex w-full space-x-6 border-b border-gray-200 bg-gray-50 px-4 py-2 sm:px-8">
            <AccountPanelIcon
                :navigation-items="navigationItemsPersonal"
                class="w-5"
                page="Personal Data"></AccountPanelIcon>
            <span class="flex-1 text-sm font-bold text-gray-700">{{ $t('account_settings.personal_data') }}</span>
            <button class="text-sm hover:text-gray-600" @click="edit">
                {{ $t('account_settings.edit') }}
            </button>
        </div>

        <div class="flex-1 pl-4 sm:pl-8">
            <dl class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2">
                <div class="flex w-full items-center space-x-3 sm:col-span-2"></div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('account.first_name') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ account.first_name }}
                    </dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('account.last_name') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ account.last_name }}
                    </dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('account.date_of_birth') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ formatDate(account.date_of_birth) }}
                    </dd>
                </div>
                <div
                    v-if="
                        !isNaturalProfileAttributeHidden('country_of_birth') &&
                        (isRequiredRequiredNaturalProfileAttributes('country_of_birth') ||
                            isRequiredNaturalProfileAttributesForInvestment('country_of_birth'))
                    "
                    class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('account.country_of_birth') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ formatCountry(account.country_of_birth) }}
                    </dd>
                </div>
                <div
                    v-if="
                        !isNaturalProfileAttributeHidden('city_of_birth') &&
                        (isRequiredRequiredNaturalProfileAttributes('city_of_birth') ||
                            isRequiredNaturalProfileAttributesForInvestment('city_of_birth'))
                    "
                    class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('account.city_of_birth') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ account.city_of_birth }}
                    </dd>
                </div>
                <div
                    v-if="
                        !isNaturalProfileAttributeHidden('gender') &&
                        (isRequiredRequiredNaturalProfileAttributes('gender') ||
                            isRequiredNaturalProfileAttributesForInvestment('gender'))
                    "
                    class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('account.gender') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ formatGender(account.gender) }}
                    </dd>
                </div>
                <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                        {{ $t('account.nationality') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ formatCountry(account.nationality) }}
                    </dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<style scoped></style>
